export default __webpack_public_path__ + "static/media/thank-you.6a6018e9.svg";